module.exports = __webpack_public_path__ + "media/homepage/builder-hero-03ee93d1.png";